export class MerchantReviewDto {  
    id: number;
    merchantId: number;
    reviewDate?: Date;
    captureDate?: Date;
    source?: string;
    rating?: number;
    title?: string;
    author?: string;
    reviewText?: string;
    reviewURL?: string; 
}